import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_ADMIN_WHOLE_VENDOR_DINER,
  GET_ADMIN_WHOLE_PENDING_DINER,
  GET_ADMIN_WHOLE_RESERVATION_DINER,
  GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS,
  GET_ADMIN_WHOLE_HISTORY_DINER,
  INC_ADMIN_WHOLE_SEATING_COUNT,
  DEC_ADMIN_WHOLE_SEATING_COUNT,
} from "../../types";
import Alert from "react-s-alert";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";
import { get_new_subscription_for_vendor } from "../authAction";

/***************************************
 * @DESC - ADD DINER AND RESERVATION ACTION
 *****************************************/
export const sa_vd_add_diner_reservation =
  (formData, token, actionText, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_diner_reservaton = await axios.post(
        `${serverApi}/diner`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_diner_reservaton.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>New ${actionText} Add Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

/***********************************************
 * @DESC - GET RESERVATION TIMING SLOTS ACTION
 **********************************************/
export const sa_vd_get_timing_slots_reservation =
  (restaurant_id, newDate, token, min_lead_time) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_timing_slots_reservation = await axios.get(
        `${serverApi}/restaurant-availability/${restaurant_id}?date=${newDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_timing_slots_reservation.data) {
        dispatch({ type: CLEAR_LOADER });
        let responseCopy = cloneDeep(get_timing_slots_reservation.data);
        let minimum = parseFloat(min_lead_time) * 60;
        let finalSlots = [];
        let indexTime;
        for (let i = 0; i < responseCopy.length; i++) {
          let time1 = moment(responseCopy[i], "hh:mm A");
          let time2 = moment(new Date(), "hh:mm A").add(minimum, "minutes");

          if (!moment(time2).isAfter(time1, "hh:mm A")) {
            // finalSlots.push(get_timing_slots_reservation.data[i]);
            indexTime = i;
            i = responseCopy.length;
          }
        }
        finalSlots = responseCopy.splice(indexTime);
        dispatch({
          type: GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS,
          payload:
            moment(newDate).format("DD-MM-YYYY") ===
            moment(new Date()).format("DD-MM-YYYY")
              ? finalSlots
              : get_timing_slots_reservation.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/******************************************
 * @DESC - GET ALL DINER INFORMATION
 *****************************************/
export const sa_whole_vd_seating_diner =
  (token, vendor_id, subscriptionId, onSuccess, onErrors) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_seating_diner = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=SEATING`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_seating_diner.status === 200) {
        dispatch({
          type: GET_ADMIN_WHOLE_VENDOR_DINER,
          payload: get_seating_diner.data,
        });
        onSuccess(vendor_id, subscriptionId);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch(setErrors(err));
      onErrors();
      dispatch({ type: CLEAR_LOADER });
    }
  };

/******************************************
 * @DESC - GET ALL PENDING INFORMATION
 *****************************************/
export const sa_whole_vd_pending_diner =
  (token, vendor_id, subscriptionId, onSuccess, onErrors) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_seating_diner = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=PENDING`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_seating_diner.status === 200) {
        dispatch({
          type: GET_ADMIN_WHOLE_PENDING_DINER,
          payload: get_seating_diner.data,
        });
        onSuccess(vendor_id, subscriptionId);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch(setErrors(err));
      onErrors();
      dispatch({ type: CLEAR_LOADER });
    }
  };

/******************************************
 * @DESC - GET ALL RESERVATION INFORMATION
 *****************************************/
export const sa_whole_vd_reservation_diner =
  (token, vendor_id, subscriptionId, onSuccess, onErrors, custom_time) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_seating_diner = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=RESERVATION&${
          custom_time === undefined
            ? ""
            : `customTime=${custom_time}` && custom_time === true
            ? `openAll=${custom_time}`
            : `customTime=${custom_time}`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_seating_diner.status === 200) {
        dispatch({
          type: GET_ADMIN_WHOLE_RESERVATION_DINER,
          payload: get_seating_diner.data,
        });
        onSuccess(vendor_id, subscriptionId);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch(setErrors(err));
      onErrors();
      dispatch({ type: CLEAR_LOADER });
    }
  };

/******************************************
 * @DESC - GET ALL HISTORY INFORMATION
 *****************************************/
export const sa_whole_vd_history_diner =
  (token, vendor_id, subscriptionId, onSuccess, onErrors) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_seating_diner = await axios.get(
        `${serverApi}/diner?vendor_id=${vendor_id}&diner_status=HISTORY`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_seating_diner.status === 200) {
        dispatch({
          type: GET_ADMIN_WHOLE_HISTORY_DINER,
          payload: get_seating_diner.data,
        });
        onSuccess(vendor_id, subscriptionId);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch(setErrors(err));
      onErrors();
      dispatch({ type: CLEAR_LOADER });
    }
  };

/***************************************
 * @DESC - MARK ALL COMPETED ACTION
 *****************************************/
export const sa_vd_mark_complete_diner =
  (formData, vendor_id, token, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let completeRecord = await axios.patch(
        `${serverApi}/diner?markComplete=${formData.markAllComplete}&vendor_id=${vendor_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (completeRecord.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - RESET DINER ACTION
 *****************************************/
export const sa_vd_reset_diner_request =
  (formData, diner_id, vendor_id, token, onCallBackSuccess) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let resetRecord = await axios.patch(
        `${serverApi}/diner/${diner_id}?vendor_id=${vendor_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (resetRecord.status === 200) {
        onCallBackSuccess();
        dispatch(
          get_new_subscription_for_vendor({
            vendor_id: formData.vendor,
          })
        );
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
